import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"

//Import Components
import CardUser from "./card-user"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"

import SalesAnalytics from "./sales-analytics"
//import TotalSellingProduct from "./total-selling-product"
import Tasks from "./tasks"
//import ChatBox from "./chat-box"
import Notifications from './notifications';
import Oerview from './overview';
import User from "./user"

import axios from "axios";
import {FACILITIES,SAMPLINGPOINTS,WQSAMPLES, PARAMETERS, COMPANY, DASHMTCE, COMPLAINTFILTER, DASHCOMPLAINTS, DASHASSETS, BILLPAYMENTS, DASHPRODUCTIONDAILY } from "helpers/url_helper";
import { Config, formatDate } from "helpers/backend_helper";

const Dashboard = props => {
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);

  const [username, setusername] = useState("--")
  const [role, setRole] = useState("--")

  const [noOfAssets, setNoOfAssets] = useState("--")

  const [yourLeaves, setYourLeaves] = useState([])

  const [noOfFacs, setNoOfFacs] = useState("--")
  const [noOfSP, setNoOfSP] = useState("--")
  const [noOfComps, setNoOfComps] = useState('--')

  const [qPs, setQPs] = useState(0)
  const [wqData, setDataList] = useState("--");
  const [params, setParamsList] = useState("--");
  const [collectionsSLSH, setCollectionsSLSH] = useState("--");
  const [collectionsUSD, setCollectionsUSD] = useState("--");
  const [waterProduced, setWaterProduced] = useState({"inflow":"--","outflow":"--","power":"--"});
  const [mtcJobs, setMTCJOBS] = useState("--");
  const [hrProfile, setHRProfile] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authWTUser")) {
        const obj = JSON.parse(localStorage.getItem("authWTUser"))
        setusername(obj.username)
        setRole(obj.title)
        if(obj.hrNo == ""){
          setHRProfile(false)
        }else{
          setHRProfile(true)
        }
    }
    axios.get(SAMPLINGPOINTS, Config).then((r)=>{ setNoOfSP(r.data.length);  }).catch((e)=>{  console.log(e); });
    axios.get(FACILITIES, Config).then((r)=>{ setNoOfFacs(r.data.length);  }).catch((e)=>{  console.log(e); });
    const qdata = {
      id: '',
      sDate: formatDate(new Date(new Date().setDate(new Date().getDate() - 8))),
      eDate: formatDate(new Date()),
      sPoint: '',
      sStaff: ''      
    }
    axios.post(WQSAMPLES, JSON.stringify(qdata), Config).then((r)=>{ 
      setDataList(r.data.length); 
      //console.log(r.data.length)  
    }).catch((e)=>{  console.log(e); });
    axios.get(PARAMETERS, Config).then((r)=>{ setParamsList(r.data.length);  }).catch((e)=>{  console.log(e); });
    axios.get(DASHASSETS, Config).then((r)=>{ setNoOfAssets(r.data.assets)}).catch((e)=>{ console.log(e)})
    axios.get(DASHMTCE, Config).then((r)=>{ setMTCJOBS(r.data[0].total)}).catch((e)=>{ console.log(e)})
    axios.get(DASHPRODUCTIONDAILY, Config).then((r)=>{ setWaterProduced(r.data); }).catch((e)=>{ console.log(e)})
    const dData = {
      refno     : "",
      phone     : "",
      area      : "",
      category  : "",
      status    : "",
      staff     : "",
      mine      : "",
      dept      : "",
      handler   : "",
      startDate : formatDate(new Date()),
      endDate   : formatDate(new Date()),}
    axios.post(COMPLAINTFILTER, JSON.stringify(dData), Config).then((r)=>{ setNoOfComps(r.data.length);}).catch((e)=>{  console.log(e); });
    const coldata = {
      receiptNo : "",
      supplyNo  : "",
      name      : "",
      phone     : "",
      vendor    : "",
      refno     : "",
      area      : "",
      status    : "Verified",
      currency  : "",
      startDate : formatDate(new Date()),
      endDate   : formatDate(new Date()),
      cashierId : ""
    }
    axios.post(BILLPAYMENTS, JSON.stringify(coldata), Config).then((r)=>{ 
      setCollectionsSLSH((r.data.reduce((total, entry) => (total + parseFloat(entry.amount)), 0)/1000000).toFixed(1).toLocaleString()+"M")
      setCollectionsUSD(r.data.reduce((total, entry) => total + parseFloat(entry.amountUSD), 0).toLocaleString())
    }).catch((e)=>{  
      console.log(e); 
    });

  }, [])
  
  useEffect(()=> {
    const leave = [

      {
        'leaveType': 'Response Time', 
        'entitled': "< 3 hours",
        'balance': "-"
      },
      {
        'leaveType': 'Fault Correction Time', 
        'entitled': "< 6 hours",
        'balance': "-"
      },
      {
        'leaveType': 'Uptime', 
        'entitled':"> 90%",
        'balance': "-"
      },
      {
        'leaveType': 'Mean Time Between Failure ', 
        'entitled': "> 1 year",
        'balance': "-"
      },
      {
        'leaveType': 'Emergency Works', 
        'entitled':"< 10%",
        'balance': "-"
      },
      {
        'leaveType': 'Planned Tasks', 
        'entitled': "> 80%",
        'balance': "-"
      },
      {
        'leaveType': 'Maintenance Backlog', 
        'entitled': "< 4 Weeks",
        'balance': "-"
      },
      {
        'leaveType': 'Overtime/subsistence', 
        'entitled': "< 12%",
        'balance': "-"
      },
      {
        'leaveType': 'Maintenance Labour Cost', 
        'entitled': "< 25% of TMC",
        'balance': "-"
      }

    ];
    setYourLeaves(leave)
  },[])



 

  const reports = [
    {
      icon: "bx bx-copy-alt",
      title: "Water Abstracted",
      value: waterProduced.inflow + "cu.m/day",
      color: "primary"
    },
    {
      icon: "bx bxs-message-square-dots",
      title: "Power Generated",
      color: "success",
      value: waterProduced.power + "kWh/day"
    }
    ,
    {
      icon: "bx bxs-message-square-dots",
      title: "Maintenance Jobs",
      color: "success",
      value: mtcJobs
    },
    {
      icon: "bx bxs-book-bookmark",
      title: "Quality Samples",
      value: wqData,
      color: "warning",
    }
];



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            Home | {COMPANY}
          </title>
        </MetaTags>
        <Container fluid>
  
           <CardUser username={username} role={role} collections={collectionsSLSH} waterProduced={waterProduced.outflow+"cu.m/day"} noOfComplaints={noOfComps} hrProfile={hrProfile} /> 
           
          <Row>
            
            <Col xl="12">
              <Row>
                <User reports={reports}/>
                
              </Row>
            </Col>
            <Oerview /> 
          </Row>


          
          <Row>
            <Notifications approvals={approvals}/>
            <Tasks leave={yourLeaves} showReports={true} />
          </Row>
         
       
          
        
     
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
